export class Pines {
    usuario: number;
    nombre: string;
    telefono: number;
    estatus: string;
    ultimo_acceso: string;
    intentos: number;
    tiene_2fa: boolean;
    email: string;
    pendiente_2fa: boolean;

    constructor({
        usuario = 0,
        nombre = "",
        telefono = 0,
        estatus = "",
        ultimo_acceso = "",
        intentos = 0,
        tiene_2fa = false,
        email = "",
        pendiente_2fa = false
    }: any) {
        this.usuario = usuario;
        this.nombre = nombre;
        this.telefono = telefono;
        this.estatus = estatus;
        this.ultimo_acceso = ultimo_acceso;
        this.intentos = intentos;
        this.tiene_2fa = tiene_2fa;
        this.email = email;
        this.pendiente_2fa = pendiente_2fa;
    }
}

export class Horarios {
    telefono: string;
    com_hf: string;
    com_hi: string;
    dom_hf: string;
    dom_hi: string;
    id_pinusr: string;
    jue_hf: string;
    jue_hi: string;
    lun_hf: string;
    lun_hi: string;
    mar_hf: string;
    mar_hi: string;
    mie_hf: string;
    mie_hi: string;
    sab_hf: string;
    sab_hi: string;
    vie_hf: string;
    vie_hi: string;

    constructor({
        telefono = "",
        com_hf = "",
        com_hi = "",
        dom_hf = "",
        dom_hi = "",
        id_pinusr = "",
        jue_hf = "",
        jue_hi = "",
        lun_hf = "",
        lun_hi = "",
        mar_hf = "",
        mar_hi = "",
        mie_hf = "",
        mie_hi = "",
        sab_hf = "",
        sab_hi = "",
        vie_hf = "",
        vie_hi = "",
    }: any) {
        this.telefono = telefono;
        this.com_hf = com_hf;
        this.com_hi = com_hi;
        this.dom_hf = dom_hf;
        this.dom_hi = dom_hi;
        this.id_pinusr = id_pinusr;
        this.jue_hf = jue_hf;
        this.jue_hi = jue_hi;
        this.lun_hf = lun_hf;
        this.lun_hi = lun_hi;
        this.mar_hf = mar_hf;
        this.mar_hi = mar_hi;
        this.mie_hf = mie_hf;
        this.mie_hi = mie_hi;
        this.sab_hf = sab_hf;
        this.sab_hi = sab_hi;
        this.vie_hf = vie_hf;
        this.vie_hi = vie_hi;
    }
}

